/**
 * More about me main menu
 */
export const AddressBook = (function () {
  var initializedOnLoad = false;

  var csrfHeaders = function () {
    return {
      "x-csrf-token":
        '{"csrf_name":"' +
        $("#csrf_name").val() +
        '","csrf_value":"' +
        $("#csrf_value").val() +
        '"}',
    };
  };

  var init = function () {


    if (typeof AddressBook.baseURL === 'undefined') {
      AddressBook.baseURL = '';
    }

    if($(".address-book-component").length < 1){
      return false;
    }

    if (!initializedOnLoad) {
      initializedOnLoad = true;
      getTable("addresses");
    }

    $(".address-book-component .add-record-button")
      .off("click")
      .on("click", function (e) {
        //clear the form ready to be populated
        $(".address-book-component .add-edit-record")
          .find("input, select")
          .each(function () {
            $(this).val("");
          });

        $(this)
          .closest(".address-book-component")
          .find(".add-edit-record")
          .removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".add-controls")
          .removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".edit-controls")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".save-add-row")
          .removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".add-record-button")
          .addClass("d-none");

          $(this)
          .closest(".address-book-component")
          .find(".input-errors")
          .html("");
          

        return false;
      });

    $(".address-book-component .person-info-modal")
      .off("click")
      .on("click", function (e) {
        $("#person-modal-content").html("");

        //ajax in the data
        var personId = $(this).closest(".data-row").attr("data-attr-id");

        $.get({
          url: MaMFormHandler.getBaseUrl()+"/get-table/addresses?row=" + personId,
          headers: csrfHeaders(),
          success: function (res) {
            if (typeof res.role_in_life == "undefined") {
              res.role_in_life = "";
            }
            if (typeof res.other_information == "undefined") {
              res.other_information = "";
            }

            $("#person-modal-content").append(
              "<h5>First Name</h5>" +
                "<p>" +
                res.first_name +
                "</p>" +
                "<h5>Surname</h5>" +
                "<p>" +
                res.surname +
                "</p>" +
                "<h5>Nickname</h5>" +
                "<p>" +
                res.nickname +
                "</p>" +
                "<h5>Home Phone</h5>" +
                "<p>" +
                res.home_phone +
                "</p>" +
                "<h5>Mobile Phone</h5>" +
                "<p>" +
                res.mobile_phone +
                "</p>" +
                "<h5>Role in Life</h5>" +
                "<p>" +
                res.role_in_life +
                "</p>" +
                "<h5>Other Information</h5>" +
                "<p>" +
                res.other_information +
                "</p>"
            );
          },
          dataType: "json",
        });

        $("#personInfoModal").modal("show");
        return false;
      });

    $(".address-book-component .edit-row")
      .off("click")
      .on("click", function (e) {
        $(this).closest("tr").next().removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".edit-record-button")
          .removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".add-record-button")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".add-edit-record")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".pagination-links")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".page-add-edit-control-row")
          .addClass("d-none");

        return false;
      });

    $(".address-book-component .edit-record")
      .off("click")
      .on("click", function (e) {
        //populate the data

        $(this)
          .closest(".address-book-component")
          .find(".add-edit-record")
          .removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".add-controls")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".edit-controls")
          .removeClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".pagination-links")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".save-inline-row")
          .addClass("d-none");

        $(this)
          .closest(".address-book-component")
          .find(".page-add-edit-control-row")
          .removeClass("d-none");

        var id = $(this).attr("data-attr-id");
        $(".edit-record-button").attr("data-attr-id", id);

        return false;
      });

    $(".address-book-component .reload-table")
      .off("click")
      .on("click", function (e) {
        var clickedElem = $(this);

        if ($(clickedElem).hasClass("order-table")) {
          if ($(clickedElem).attr("data-attr-order") == "up") {
            $(clickedElem).attr("data-attr-order", "down");
          } else {
            $(clickedElem).attr("data-attr-order", "up");
          }
        }

        $(clickedElem)
          .find(".order-icon")
          .each(function () {
            $(this).toggleClass("d-none");
          });

        getTable("addresses");
        return false;
      });

    $(".address-book-component .btn-prev-page")
      .off("click")
      .on("click", function (e) {
        var activePage = parseInt(
          $(this).closest(".address-book-component").attr("data-active-page")
        );

        if (activePage <= 1) {
          return false;
        }

        activePage--;

        $(this)
          .closest(".address-book-component")
          .attr("data-active-page", activePage);

        getTable("addresses");

        return false;
      });

    $(".address-book-component .btn-next-page")
      .off("click")
      .on("click", function (e) {
        var activePage = parseInt(
          $(this).closest(".address-book-component").attr("data-active-page")
        );

        activePage++;

        $(this)
          .closest(".address-book-component")
          .attr("data-active-page", activePage);

        getTable("addresses");

        return false;
      });

    $(".address-book-component .save-inline-row")
      .off("click")
      .on("click", function (e) {
        var payload = {};
        payload.id = $(this).closest(".edit-mode").attr("data-attr-id");
        var editRecordElement = $(this);

        $(this)
          .closest(".edit-mode")
          .find("input, select")
          .each(function () {
            payload[$(this).attr("name")] = $(this).val();
          });

        $(this).closest(".edit-mode").addClass("d-none");

        var dataViewRow = $(this)
          .closest(".edit-mode")
          .parent()
          .find('.data-row[data-attr-id="' + payload.id + '"]');

        $.post({
          url: MaMFormHandler.getBaseUrl()+"/update-table-row/addresses",
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            $(editRecordElement)
              .closest(".address-book-component")
              .find(".page-add-edit-control-row, .page-add-edit-control-row *")
              .removeClass("d-none");

            $(editRecordElement)
              .closest(".address-book-component")
              .find(".save-add-row")
              .addClass("d-none");

            $(editRecordElement)
              .closest(".address-book-component")
              .find(".edit-controls")
              .addClass("d-none");
          },
          dataType: "json",
        });

        $(dataViewRow)
          .find("td")
          .each(function () {
            $(this).html(payload[$(this).attr("name")]);
          });

        return false;
      });

    $(".address-book-component .edit-record-button")
      .off("click")
      .on("click", function (e) {
        var payload = [];
        payload.id = $(this).attr("data-attr-id");

        $(this)
          .closest(".address-book-component")
          .find('.edit-mode[data-attr-id="' + payload.id + '"]')
          .find("input, select")
          .each(function () {
            payload[$(this).attr("name")] = $(this).val();
          });

        $(this)
          .closest(".address-book-component")
          .find(
            ".detail-controls input, .detail-controls select, .detail-controls textarea"
          )
          .each(function () {
            payload[$(this).attr("name")] = $(this).val();
          });

        var dataViewRow = $('.edit-mode[data-attr-id="' + payload.id + '"]')
          .parent()
          .find('.data-row[data-attr-id="' + payload.id + '"]');

        //ajax save here
        $(dataViewRow)
          .find("td")
          .each(function () {
            $(this).html(payload[$(this).attr("name")]);
          });

        $(".add-edit-record").addClass("d-none");
        $('.edit-mode[data-attr-id="' + payload.id + '"]').addClass("d-none");

        $(".add-record-button").removeClass("d-none");
        $(".edit-record-button").addClass("d-none");
        return false;
      });

    $(".address-book-component .delete-row")
      .off("click")
      .on("click", function (e) {
        if (!confirm("Delete this person, are you sure?")) {
          return false;
        }

        var payload = {};
        payload.id = $(this).closest(".data-row").attr("data-attr-id");

        var dataViewRow = $(this).closest(".data-row");

        $.post({
          url: MaMFormHandler.getBaseUrl()+"/delete-table-row/" + payload.id,
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            $(dataViewRow)
              .find("td")
              .each(function () {
                $(this).remove();
              });
          },
          dataType: "json",
        });

        return false;
      });

    $(".address-book-component .save-add-row")
      .off("click")
      .on("click", function (e) {
        var payload = {};

        var addRecordElement = $(this);

        $(".address-book-component .add-edit-record")
          .find("input, select")
          .each(function () {
            payload[$(this).attr("name")] = $(this).val();
          });

        $.post({
          url: MaMFormHandler.getBaseUrl()+"/add-table-row/addresses",
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {

            if(res.success == false){
              $.each(res.errors, function(idx, error){
                $(addRecordElement).closest(".address-book-component").find('.input-error-'+idx).html(error);
              });
              return;
            }

            $(addRecordElement)
              .closest(".address-book-component")
              .find(".add-edit-record")
              .addClass("d-none");

            $(addRecordElement)
              .closest(".address-book-component")
              .find(".add-controls")
              .addClass("d-none");

            $(addRecordElement)
              .closest(".address-book-component")
              .find(".edit-controls")
              .addClass("d-none");

            $(addRecordElement)
              .closest(".address-book-component")
              .find(".add-record-button")
              .removeClass("d-none");

            $(addRecordElement)
              .closest(".address-book-component")
              .find(".save-add-row")
              .addClass("d-none");

            getTable("addresses");
            return false;
          },
          dataType: "json",
        });

        return false;
      });
  };

  var getTable = function (field) {
    //populate the ordering/pagination/search

    var params = {};

    params.activePage = parseInt(
      $(".address-book-component").attr("data-active-page")
    );
    params.ordering = [];
    $(".address-book-component .reload-table").each(function () {
      var column = $(this).attr("data-attr-col");
      var order = $(this).attr("data-attr-order");

      params.ordering.push({
        [column]: order,
      });
    });

    params.searchValue = $(
      '.address-book-component input[name="search-value"]'
    ).val();

    if (params) {
      params = $.param(params);
    }

    $.get({
      url: MaMFormHandler.getBaseUrl()+"/get-table/addresses?field=" + field + "&" + params,
      headers: csrfHeaders(),
      success: function (res) {
        $(
          ".address-book-component .data-table .data-row, .address-book-component .data-table .edit-mode"
        ).remove();

        res.forEach((row, idx) => {
          var rowTemplate = $(".address-book-component .table-row-template tbody").html();
          if (typeof row.role_in_life == "undefined") {
            row.role_in_life = "";
          }
          if (typeof row.other_information == "undefined") {
            row.other_information = "";
          }
          rowTemplate = rowTemplate
            .replaceAll("replace-idx", row.id)
            .replaceAll("replace-first_name", row.first_name)
            .replaceAll("replace-surname", row.surname)
            .replaceAll("replace-home_phone", row.home_phone)
            .replaceAll("replace-mobile_phone", row.mobile_phone)
            .replaceAll("replace-email", row.email)
            .replaceAll("replace-nickname", row.nickname)
            .replaceAll("replace-role_in_life", row.role_in_life)
            .replaceAll("replace-other_information", row.other_information);
          $(".address-book-component .data-table tbody").append(rowTemplate);
        });
        AddressBook.init();
      },
      dataType: "json",
    });
  };

  return {
    init: init
  };
})();
